module.exports = __webpack_public_path__ + "static/check5-8af0f482fff03ec42e1b7d68e8747ed1.png";